<template>
     <div class="v-flex " v-if="item.type === 2" >
         <p-dms-rename
             v-model   = "openRename"
             :filename = "item.name"
             @save     = "onSave"
         />

         <!--
        <v-menu
            v-model     = "showMenu"
            :position-x = "x"
            :position-y = "y"
            absolute
            offset-y
        >
            <v-list>
                <v-list-item link @click="onEdit">
                    <v-list-item-title>Umbenennen</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="onSync">
                    <v-list-item-title>synchronisieren</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        -->

        <a
            :class       = "!item.dmsId ? 'secondary--text' : 'primary--text'"
            @click       = "onDocument(item)"
            @contextmenu = "onContextMenu"
        >
            <p-dms-treeview-entry
                :entry = "item"
            >
                <template v-slot:icon>
                    <div style = "width: 25px;">
                        <v-icon
                            size  = "21"
                            color = "primary"
                        >
                            {{ icon (item) }}
                        </v-icon>
                    </div>

                </template>
            </p-dms-treeview-entry>
        </a>
    </div>
</template>

<script>

import Core              from "@/modules/core/service/Core";
import Dms               from "@/modules/dms/common/service/Dms";
import PDmsRename        from "@/modules/dms/treeview/components/private/PDmsRename.vue";
import PDmsTreeviewEntry from "@/modules/dms/treeview/components/private/PDmsTreeviewEntry.vue";

export default {
    name: "PDmsTreeviewFile",

    components: {
        PDmsTreeviewEntry,
        PDmsRename
    },

    props: {
        item: {
            required: true,
            type    : Object,

            default : () => {
                return {
                    name : null,
                    dmsId: null,
                    filetype: {
                        id: null,
                    }
                }
            }
        }
    },

    data: () => ({
        openRename : false,
        selected   : null,
        mailContent: null,
        showMenu   : false,
        x: 0,
        y: 0,
    }),

    methods: {
        onContextMenu (e) {
            e.preventDefault();
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
        },

        onEdit () {
            this.openRename = true;
        },

        onSave (filename) {
            Dms.rename(this.item.id, filename, () => {
                this.item.name = filename;
            })
        },

        onSync () {
            Core.loading(this,true);
            Dms.sync(this.item.id, (data) => {
                this.item.name = data.name;
                Core.loading(this,false);
            }).catch(() => {
                Core.loading(this,false);
            })
        },

        onDocument (document) {
            this.$emit("document", document)
        },

        icon (document) {
            return Dms.icon(document.filetype.mime, document.filetype.extension);
        }
    }
}
</script>

<style scoped>

</style>